import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../../screens/communities/components/GroupMembersList/__generated__/user.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProtegesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProtegesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, proteges: Array<{ __typename?: 'User', info?: string | null, id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }>, superPalOf: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }>, temporaryCaregiverOf: Array<{ __typename?: 'UserTemporaryConnection', endDate: number, user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, caregiverOf: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }> } };

export type ProtegesListUpdatedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type ProtegesListUpdatedSubscription = { __typename?: 'Subscription', protegesListUpdated: { __typename?: 'ProtegesListUpdatedPayload', removedUuid?: string | null, added?: { __typename?: 'User', info?: string | null, id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } };


export const GetProtegesDocument = gql`
    query GetProteges {
  currentUser {
    id
    proteges {
      ...UserBasicInfo
      info
    }
    superPalOf {
      ...UserBasicInfo
    }
    temporaryCaregiverOf {
      user {
        ...UserBasicInfo
      }
      endDate
    }
    caregiverOf {
      ...UserBasicInfo
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;

/**
 * __useGetProtegesQuery__
 *
 * To run a query within a React component, call `useGetProtegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtegesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProtegesQuery(baseOptions?: Apollo.QueryHookOptions<GetProtegesQuery, GetProtegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtegesQuery, GetProtegesQueryVariables>(GetProtegesDocument, options);
      }
export function useGetProtegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtegesQuery, GetProtegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtegesQuery, GetProtegesQueryVariables>(GetProtegesDocument, options);
        }
// @ts-ignore
export function useGetProtegesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProtegesQuery, GetProtegesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtegesQuery, GetProtegesQueryVariables>;
export function useGetProtegesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtegesQuery, GetProtegesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtegesQuery | undefined, GetProtegesQueryVariables>;
export function useGetProtegesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtegesQuery, GetProtegesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProtegesQuery, GetProtegesQueryVariables>(GetProtegesDocument, options);
        }
export type GetProtegesQueryHookResult = ReturnType<typeof useGetProtegesQuery>;
export type GetProtegesLazyQueryHookResult = ReturnType<typeof useGetProtegesLazyQuery>;
export type GetProtegesSuspenseQueryHookResult = ReturnType<typeof useGetProtegesSuspenseQuery>;
export type GetProtegesQueryResult = Apollo.QueryResult<GetProtegesQuery, GetProtegesQueryVariables>;
export const ProtegesListUpdatedDocument = gql`
    subscription ProtegesListUpdated {
  protegesListUpdated {
    added {
      ...UserBasicInfo
      info
    }
    removedUuid
  }
}
    ${UserBasicInfoFragmentDoc}`;

/**
 * __useProtegesListUpdatedSubscription__
 *
 * To run a query within a React component, call `useProtegesListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProtegesListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProtegesListUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProtegesListUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ProtegesListUpdatedSubscription, ProtegesListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProtegesListUpdatedSubscription, ProtegesListUpdatedSubscriptionVariables>(ProtegesListUpdatedDocument, options);
      }
export type ProtegesListUpdatedSubscriptionHookResult = ReturnType<typeof useProtegesListUpdatedSubscription>;
export type ProtegesListUpdatedSubscriptionResult = Apollo.SubscriptionResult<ProtegesListUpdatedSubscription>;